import { render, staticRenderFns } from "./FormInputFormat.vue?vue&type=template&id=6a7ff052&scoped=true"
import script from "./FormInputFormat.vue?vue&type=script&lang=js"
export * from "./FormInputFormat.vue?vue&type=script&lang=js"
import style0 from "./FormInputFormat.vue?vue&type=style&index=0&id=6a7ff052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ff052",
  null
  
)

export default component.exports